import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import slug from 'slug'
import { List } from './List'
import styled from 'styled-components'

export const TagsGroup = () => {
  const data = useStaticQuery(graphql`
    {
      allMarkdownRemark {
        group(field: { frontmatter: { tags: SELECT } }) {
          name: fieldValue
          count: totalCount
        }
      }
    }
  `)

  const tags = data.allMarkdownRemark.group
  return (
    <List title="Tags">
      {tags.map((tag) => {
        return (
          <Tag key={tag.name}>
            <Link to={`/tags/${slug(tag.name)}`}>
              #{tag.name} ({tag.count})
            </Link>
          </Tag>
        )
      })}
    </List>
  )
}

const Tag = styled(List.Item)`
  line-height: 1;
`
